import { IconButton, CircularProgress } from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import MailIcon from '@mui/icons-material/Mail';
import ArticleIcon from '@mui/icons-material/Article';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import VerifiedIcon from '@mui/icons-material/Verified';
import Fade from '@mui/material/Fade';
import * as theme from '../../../theme';

export default function ScanStatusItem({ children, ...props }) {
  const getIcon = () => {
    if (props.icon) {
      if (props.icon === 'money') {
        return <PaymentIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'mail') {
        return <MailIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'report') {
        return <ArticleIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'cancelled') {
        return <EventBusyIcon sx={{ flex: '0 0 auto' }} />;
      } else if (props.icon === 'complete') {
        return <VerifiedIcon sx={{ flex: '0 0 auto' }} />;
      }
    }
  };

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={props.disabled ? 'cardLinkDisabled' : 'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          {getIcon()}
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.label}
            <br />
            <Fade in={true} timeout={300}>
              <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>
                {props.content ? props.content : <br/>}
              </span>
            </Fade>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flex: 0.5, justifyContent: 'right', width: '100%' }}>
        {props.disabled && props.nextUp ? (
          <Fade in={true} timeout={300}>
            <IconButton
              aria-label="complete"
              color="secondary"
              onClick={props.canComplete && !props.processing ? () => props.onComplete(props.action) : undefined}
              disabled={!props.canComplete || props.processing}
            >
              {props.processing ? (
                <CircularProgress size={24} color="secondary" />
              ) : (
                <VerifiedIcon sx={{ fontSize: 24 }} />
              )}
            </IconButton>
          </Fade>
        ) : !props.disabled ? (
          <IconButton
            aria-label="complete"
            color="primary"
            disabled
          >
            <VerifiedIcon sx={{ fontSize: 24 }} color="primary" />
          </IconButton>
        ) : props.disabled && !props.nextUp ? (
          <IconButton
            aria-label="complete"
            color="secondary"
            disabled
          >
            <VerifiedIcon sx={{ fontSize: 24 }} />
          </IconButton>
        ) : null}
      </div>
    </div>
  );
}